module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/1_43a23b49a7d7be52be26f6dba6737902.png";